import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Fixed circular button on the right side that smooth-scrolls back
 * to the top of the page. Mirrors the visual rhythm of the
 * LeaderboardPanel FAB on the left so the layout feels balanced.
 *
 * Visibility: appears once the user has scrolled more than ~400px
 * down so it doesn't clutter the viewport on a fresh page-load.
 */
const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <>
      <style>{`
        /* Button = Tap-Fläche (bleibt bei 44px Mindest-Touch-Target, das
           App.css global erzwingt), transparent. Der sichtbare Kreis ist
           kleiner und steckt innen -> wirkt kompakter, bleibt gut tappbar. */
        .stt-fab {
          position: fixed;
          right: 12px;
          bottom: 74px;
          z-index: 45;
          background: transparent;
          border: none;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .stt-circle {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: linear-gradient(135deg, #0f1a12, #1a2e20);
          border: 1.5px solid rgba(16, 185, 129, 0.3);
          box-shadow: 0 4px 16px rgba(0,0,0,0.35), 0 0 10px rgba(16, 185, 129, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #6ee7b7;
          transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
          opacity: 0.9;
        }
        .stt-fab:hover .stt-circle {
          transform: scale(1.1);
          opacity: 1;
          box-shadow: 0 6px 28px rgba(0,0,0,0.4), 0 0 20px rgba(16, 185, 129, 0.25);
        }
        /* Desktop: größerer Kreis + Eck-Position, kein Platzkonflikt mit
           der BottomNav (und dort greift das 44px-Min nicht). */
        @media (min-width: 768px) {
          .stt-fab { right: 20px; bottom: 24px; }
          .stt-circle { width: 48px; height: 48px; border-width: 2px; }
        }
      `}</style>
      <button
        type="button"
        className="stt-fab"
        aria-label="Nach oben scrollen"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        data-testid="scroll-to-top-btn"
      >
        <span className="stt-circle">
          <ArrowUp size={18} />
        </span>
      </button>
    </>
  );
};

export default ScrollToTopButton;
